<template>
  <div class="trans">
    <Header />
    <section class="register-page section-b-space mt90">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <form class="theme-form" v-on:submit="checkForm" method="post">
              <div v-if="errors.length">
                <ul class="validation-error mb-3">
                  <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
                </ul>
              </div>
              <h2 class="text-center register-title">Verify Phone Number</h2>
              <div class="w-90 verify-form">
                <div class="form-row">
                  <div class="col-md-6 mt-3">
                    <label for="username" class="mb-1">Email User Name</label>
                    <input
                        type="text"
                        class="form-control"
                        id="username"
                        v-model="username"
                        placeholder="support@unibud.com"
                        name="username"
                        required
                    />
                  </div>
                  <div class="col-md-6 mt-3">
                    <label for="code" class="mb-1">Verification Code</label>
                    <input
                        type="text"
                        class="form-control"
                        id="code"
                        v-model="code"
                        placeholder="Enter the 6 digit code"
                        name="code"
                        required
                    />
                  </div>
                </div>
                <p>{{signup_email_phone}}</p>
                <button class="btn btn-register" v-if="show_resend_button === 1"  @click="resend">No code received? Send it again.</button>
                <div class="form-group d-flex justify-content-center">
                  <input
                      type="submit"
                      class="btn btn-register mt-5"
                      value="Continue"
                  >
                </div>
                <Pagination :number="3" />
              </div>
            </form>
            <br>
          </div>
        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import Header from '../../components/header'
import Footer from '../../components/footer'
import Pagination from '../../components/widgets/dot-pagination'


import {confirmSignUp, resendSignUp} from '@/utils/auth.js'
import {mapGetters} from "vuex";

export default {
  components: {
    Header,
    Footer,
    Pagination
  },
  data() {
    return {
      errors: [],
      username: "",
      code: "",
      resendDelayTimer: null,
      show_resend_button: 0,
      alreadyconfirmed: 0,
      error_message: '',
    }
  },
  computed: {
    ...mapGetters({
      registration_data: 'auth/getRegistrationData',
      signup_phone_number: 'auth/signup_phone_number',
      signup_email_phone: 'cart/signup_email_phone',
    }),
  },
  mounted () {
    this.$store.dispatch('auth/setSigninLog',{type: 'signup_page_register_verify_opened', 'signinusername': this.registration_data.user_name});
    this.username = this.registration_data.user_name;
    this.startResendButtonDelayTimer();
  },
  beforeDestroy() {
    clearInterval(this.resendDelayTimer);
    this.reset_global_error();
  },
  watch: {
    error_message: async function() {
      if(this.error_message === 'User cannot be confirmed. Current status is CONFIRMED') {
        this.alreadyconfirmed = 1;
      }
    },
  },
  methods: {
    startResendButtonDelayTimer: function () {
      this.resendDelayTimer = setInterval(function () {
        clearInterval(this.resendDelayTimer);
        this.show_resend_button = 1;
      }.bind(this), 60000);
    },
    checkForm:async function (e) {
      this.errors = []

      if (!this.username) {
        this.errors.push('Username required.')
      }

      if (!this.code) {
        this.errors.push('Code required.')
      } else if (!this.validcode(this.code)) {
        this.errors.push('Minimum 6 characters in Code.')
      }

      e.preventDefault();
      if (!this.errors.length) {
        if(this.alreadyconfirmed === 1) {
          this.$store.dispatch('auth/setSigninLog',{type: 'signup_page_register_verify_skip_1', 'signinusername': this.registration_data.user_name + '*error=' + this.error_message + '*phone=' + this.signup_phone_number});
          this.$router.push({path: '/account/register3'})
        }
        else {
          try {
            var res= await confirmSignUp(this.username, this.code)
            if(res.err){
              this.errors.push(res.err.message)
              this.error_message = res.err.message;
              this.$store.dispatch('auth/setSigninLog',{type: 'signup_page_register_verify_error_1', 'signinusername': this.registration_data.user_name + '*error=' + this.error_message + '*phone=' + this.signup_phone_number});
            }
          }catch(err) {
            this.errors.push(err.message);
            this.error_message = err.message;
            this.$store.dispatch('auth/setSigninLog',{type: 'signup_page_register_verify_error_2', 'signinusername': this.registration_data.user_name + '*error=' + this.error_message + '*phone=' + this.signup_phone_number});
          }
        }
      }
    },
    resend() {
      resendSignUp(this.username);
      this.show_resend_button = 0;
      this.$store.dispatch('auth/setSigninLog',{type: 'signup_page_register_verify_resend', 'signinusername': this.registration_data.user_name});
      this.startResendButtonDelayTimer();
    },
    validcode: function (code) {
      const ps = /.{6,}/
      return ps.test(code)
    }
  }
}
</script>

